import { Directive, HostListener, Input, Optional } from '@angular/core';
import { FormControlName } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input[formControlName]'
})
export class TrimDirective {

  @Input() type!: string;

  constructor(
    @Optional() private formControlName?: FormControlName
  ) { }

  @HostListener('blur')
  @HostListener('keydown.enter')
  trimValue() {
    const control = this.formControlName?.control;
    if (typeof control?.value === 'string' && this.type !== 'password' && this.type !== 'file') {
      control.setValue(control.value.trim());
    }
  }

}
